import React, { Component } from 'react'
import { observer } from 'mobx-react'
import WebsitesStore from '../../../stores/websites'
import StoreAutoComplete from '../../util/auto_complete/StoreAutoComplete'
import Icon from '../../util/Icon'

@observer
export default class TransferSelector extends Component {

  state = {
    loadingWebsites: false,
  }

  handleTeamSelect = team => {
    if (!team) {
      this.setState({ loadingWebsites: false })
      this.websitesStore = null
      this.props.onWebsiteSelect(null)
      return
    }
    this.setState({ loadingWebsites: true })
    this.websitesStore = new WebsitesStore({ team })
    this.websitesStore.load().then(() => {
      this.setState({ loadingWebsites: false })
    })
  }

  renderWebsiteSelector() {
    const { loadingWebsites } = this.state
    if (loadingWebsites) {
      return (
        <div className="chooser-wrapper">
          <Icon className="fa-spin" icon="spinner" />
        </div>
      )
    }
    if (this.websitesStore && this.websitesStore.loaded) {
      const { onWebsiteSelect, excludeWebsites } = this.props
      return (
        <div className="chooser-wrapper">
          <br />
          <label>Website:</label>
          <StoreAutoComplete 
            placeholder="Choose A Website"
            onSelect={onWebsiteSelect}
            exclude={excludeWebsites}
            store={this.websitesStore} />
        </div>
      )
    }
  }

  render() {
    const { title, teamStore } = this.props
    return (
      <div className="transfer-selector">
        <div className="title">{title}</div>
        <div className="content">

          <div className="chooser-wrapper">
            <label>Account:</label>
            <StoreAutoComplete
              placeholder="Choose An Account"
              onSelect={this.handleTeamSelect}
              store={teamStore} />
          </div>

          {this.renderWebsiteSelector()}

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// client/components/sections/Transfers/transfer_selector.js